import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: "#1a90ff",
      backgroundColor: "transparent",
    },
    pageRoot: {
      width: "100%",
      marginTop: theme.spacing(1),
    },
    categoryCard: {
      border: `1px solid ${theme.palette.divider}`,
      borderRadius: theme.shape.borderRadius * 1.5,
      padding: theme.spacing(3),
      backgroundColor: theme.palette.background.paper,
      boxShadow: "0 1px 3px rgba(7, 6, 57, 0.06)",
      height: "100%",
      display: "flex",
      flexDirection: "column",
    },
    cardTitle: {
      fontSize: 18,
      fontWeight: 600,
      color: "#070639",
      marginBottom: theme.spacing(2),
      paddingBottom: theme.spacing(1.5),
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
    formField: {
      marginBottom: theme.spacing(3),
    },
    helperText: {
      marginTop: theme.spacing(1),
      fontSize: 10,
      color: "#6B7280",
      lineHeight: 1.5,
    },
    fieldLabel: {
      fontSize: 14,
      fontWeight: 400,
      color: "#070639",
      display: "block",
      marginBottom: theme.spacing(1),
    },
    cacheField: {
      display: "flex",
      flexDirection: "column",
      alignItems: "stretch",
      width: "100%",
    },
    cacheInfoBox: {
      width: "100%",
      padding: theme.spacing(1.5, 2),
      borderRadius: theme.shape.borderRadius,
      backgroundColor: "#F9FAFB",
      border: `1px solid ${theme.palette.divider}`,
      marginBottom: theme.spacing(2),
      boxSizing: "border-box",
    },
    cacheInfoText: {
      display: "block",
      fontSize: 12,
      color: "#6B7280",
      lineHeight: 1.6,
    },
    cacheActionRow: {
      display: "flex",
      justifyContent: "flex-start",
      width: "100%",
    },
    cacheButton: {
      textTransform: "none",
      fontWeight: 500,
      fontSize: 14,
      paddingLeft: theme.spacing(2.5),
      paddingRight: theme.spacing(2.5),
    },
    buttonContainer: {
      marginTop: theme.spacing(4),
      display: "flex",
      justifyContent: "center",
    },
  })
);

